import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { listSitesQuery } from "@visioni/a3s-provisioning/app";
import type { SiteListItem } from "@visioni/a3s-provisioning/client-messages";
import { useTenantId } from "@src/features/tenants";

const STALE_TIME_MS = 5 * 60_000;

export function useSites({ enabled = true }: { enabled?: boolean } = {}): {
  sites: SiteListItem[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
} {
  const apiConfig = useApiConfig();
  const tenantId = useTenantId();

  const query = useQuery({
    ...listSitesQuery(apiConfig, {}),
    enabled: enabled && !!tenantId,
    staleTime: STALE_TIME_MS,
  });

  const data = query.data as { sites: SiteListItem[] } | undefined;
  return {
    sites: data?.sites,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
